import type { ReactNode } from "react";
import { Sparkles } from "lucide-react";

export function ImageGenerationActions({
  canGenerate,
  generating,
  disabled,
  hasResult,
  submit,
  paused = false,
  sketch = false,
  children,
}: {
  canGenerate: boolean;
  generating: boolean;
  disabled: boolean;
  hasResult: boolean;
  submit: () => void;
  paused?: boolean;
  sketch?: boolean;
  /** Output settings shown beside the action, such as image size. */
  children?: ReactNode;
}) {
  return (
    <>
      <div className="creative-generate-row">
        <div className="creative-generate-settings">{children}</div>
        <button
          type="button"
          className={hasResult ? "creative-secondary" : "primary"}
          disabled={paused || disabled || !canGenerate || generating}
          onClick={submit}
        >
          <Sparkles size={16} />
          {generating ? "Generating…" : "Generate"}
        </button>
      </div>
      <small className="creative-disclosure">
        {paused
          ? "AI generation is paused."
          : sketch
            ? "Sketch preview and prompt are sent to Google."
            : "Image, references and prompt are sent to Google."}
      </small>
      {!canGenerate && !paused && (
        <small>Only the project owner can generate.</small>
      )}
    </>
  );
}
